const Countries = [
"Afghanistan",
"landIslands","Albania",

"Algeria",

"AmericanSamoa",

"AndorrA",

"Angola",

"Anguilla",

"Antarctica",

"AntiguaandBarbuda",

"Argentina",

"Armenia",

"Aruba",

"Australia",

"Austria",

"Azerbaijan",

"Bahamas",

"Bahrain",

"Bangladesh",

"Barbados",

"Belarus",

"Belgium",

"Belize",

"Benin",

"Bermuda",

"Bhutan",

"Bolivia",

"BosniaandHerzegovina",

"Botswana",

"BouvetIsland",

"Brazil",

"India",

"BruneiDarussalam",

"Bulgaria",

"BurkinaFaso",

"Burundi",

"Cambodia",

"Cameroon",

"Canada",

"CapeVerde",

"CaymanIslands",

"CentralAfricanRepublic",

"Chad",

"Chile",

"China",

"ChristmasIsland",

"Cocos(Keeling)Islands",

"Colombia",

"Comoros",

"Congo",

"Congo,TheDemocraticRepublicofthe",

"CookIslands",

"CostaRica",

"CoteD\"Ivoire",

"Croatia",

"Cuba",

"Cyprus",

"CzechRepublic",

"Denmark",

"Djibouti",

"Dominica",

"DominicanRepublic",

"Ecuador",

"Egypt",

"ElSalvador",

"EquatorialGuinea",

"Eritrea",

"Estonia",

"Ethiopia",

"FalklandIslands(Malvinas)",

"FaroeIslands",

"Fiji",

"Finland",

"France",

"FrenchGuiana",

"FrenchPolynesia",

"FrenchSouthernTerritories",

"Gabon",

"Gambia",

"Georgia",

"Germany",

"Ghana",

"Gibraltar",

"Greece",

"Greenland",

"Grenada",

"Guadeloupe",

"Guam",

"Guatemala",

"Guernsey",

"Guinea",

"Guinea-Bissau",

"Guyana",

"Haiti",

"HeardIslandandMcdonaldIslands",

"HolySee(VaticanCityState)",

"Honduras",

"HongKong",

"Hungary",

"Iceland",

"India",

"Indonesia",

"Iran,IslamicRepublicOf",

"Iraq",

"Ireland",

"IsleofMan",

"Israel",

"Italy",

"Jamaica",

"Japan",

"Jersey",

"Jordan",

"Kazakhstan",

"Kenya",

"Kiribati",

"Korea,DemocraticPeople\"SRepublicof",

"Korea,Republicof",

"Kuwait",

"Kyrgyzstan",

"LaoPeople\"SDemocraticRepublic",

"Latvia",

"Lebanon",

"Lesotho",

"Liberia",

"LibyanArabJamahiriya",

"Liechtenstein",

"Lithuania",

"Luxembourg",

"Macao",

"Macedonia,TheFormerYugoslavRepublicof",

"Madagascar",

"Malawi",

"Malaysia",

"Maldives",

"Mali",

"Malta",

"MarshallIslands",

"Martinique",

"Mauritania",

"Mauritius",

"Mayotte",

"Mexico",

"Micronesia,FederatedStatesof",

"Moldova,Republicof",

"Monaco",

"Mongolia",

"Montenegro",

"Montserrat",

"Morocco",

"Mozambique",

"Myanmar",

"Namibia",

"Nauru",

"Nepal",

"Netherlands",

"NetherlandsAntilles",

"NewCaledonia",

"NewZealand",
"New york",
"Nicaragua",

"Niger",

"Nigeria",

"Niue",

"NorfolkIsland",

"NorthernMarianaIslands",

"Norway",

"Oman",

"Pakistan",

"Palau",

"PalestinianTerritory,Occupied",

"Panama",

"PapuaNewGuinea",

"Paraguay",

"Peru",

"Philippines",

"Pitcairn",

"Poland",

"Portugal",

"PuertoRico",

"Qatar",

"Reunion",

"Romania",

"RussianFederation",

"RWANDA",

"SaintHelena",

"SaintKittsandNevis",

"SaintLucia",

"SaintPierreandMiquelon",

"SaintVincentandtheGrenadines",

"Samoa",

"SanMarino",

"SaoTomeandPrincipe",

"SaudiArabia",

"Senegal",

"Serbia",

"Seychelles",

"SierraLeone",

"Singapore",

"Slovakia",

"Slovenia",

"SolomonIslands",

"Somalia",

"SouthAfrica",

"SouthGeorgiaandtheSouthSandwichIslands",

"Spain",

"SriLanka",

"Sudan",

"Suriname",

"SvalbardandJanMayen",

"Swaziland",

"Sweden",

"Switzerland",

"SyrianArabRepublic",

"Taiwan,ProvinceofChina",

"Tajikistan",

"Tanzania,UnitedRepublicof",

"Thailand",

"Timor-Leste",

"Togo",

"Tokelau",

"Tonga",

"TrinidadandTobago",

"Tunisia",

"Turkey",

"Turkmenistan",

"TurksandCaicosIslands",

"Tuvalu",

"Uganda",

"Ukraine",

"UnitedArabEmirates",

"UnitedKingdom",

"UnitedStates",

"UnitedStatesMinorOutlyingIslands",

"Uruguay",

"Uzbekistan",
"Usa",
"Uk",
"X",
"Vanuatu",

"Venezuela",

"VietNam",

"VirginIslands,British",

"VirginIslands,U.S.",

"WallisandFutuna",

"WesternSahara",

"Yemen",

"Zambia",

"Zimbabwe",
"Mumbai",
"Delhi",
"Bengaluru",
"Ahmedabad",
"Hyderabad",
"Chennai",
"Kolkata",
"Pune",
"Jaipur",
"Surat",
"Lucknow",
"Kanpur",
"Nagpur",
"Patna",
"Indore",
"Thane",
"Bhopal",
"Visakhapatnam",
"Vadodara",
"Firozabad",
"Ludhiana",
"Rajkot",
"Agra",
"Siliguri",
"Nashik",
"Faridabad",
"Patiala",
"Meerut",
"Kalyan-Dombivali",
"Vasai-Virar",
"Varanasi",
"Srinagar",
"Dhanbad",
"Jodhpur",
"Amritsar",
"Raipur",
"Allahabad",
"Coimbatore",
"Jabalpur",
"Gwalior",
"Vijayawada",
"Madurai",
"Guwahati",
"Chandigarh",
"Hubli-Dharwad",
"Amroha",
"Moradabad",
"Gurgaon",
"Aligarh",
"Solapur",
"Ranchi",
"Jalandhar",
"Tiruchirappalli",
"Bhubaneswar",
"Salem",
"Warangal",
"Mira-Bhayandar",
"Thiruvananthapuram",
"Bhiwandi",
"Saharanpur",
"Guntur",
"Amravati",




"Bikaner",




"Noida",




"Jamshedpur",




"BhilaiNagar",




"Cuttack",




"Kochi",




"Udaipur",




"Bhavnagar",
"Dehradun",




"Asansol",




"Nanded-Waghala",




"Ajmer",




"Jamnagar",




"Ujjain",




"Sangli",




"Loni",




"Jhansi",




"Pondicherry",
"Nellore",




"Jammu",




"Belagavi",



"Raurkela",




"Mangaluru",



"Tirunelveli",




"Malegaon",




"Gaya",




"Tiruppur",




"Davanagere",
"Kozhikode",




"Akola",




"Kurnool",




"BokaroSteelCity",




"Rajahmundry",




"Ballari",
"Agartala",




"Bhagalpur",




"Latur",




"Dhule",
"Korba",




"Bhilwara",




"Brahmapur",




"Mysore",
"Muzaffarpur",




"Ahmednagar",




"Kollam",




"Raghunathganj",




"Bilaspur",




"Shahjahanpur",
"Thrissur",




"Alwar",




"Kakinada",




"Nizamabad",




"Sagar",




"Tumkur",
"Hisar",




"Rohtak",




"Panipat",




"Darbhanga",
"Kharagpur",




"Aizawl",




"Ichalkaranji",




"Tirupati",




"Karnal",




"Bathinda",




"Rampur",




"Shivamogga",
"Ratlam",




"Modinagar",
"Durg",




"Shillong",




"Imphal",




"Hapur",




"Ranipet",




"Anantapur",




"Arrah",




"Karimnagar",




"Parbhani",




"Etawah",
"Bharatpur",




"Begusarai",




"NewDelhi",




"Chhapra",




"Kadapa",




"Ramagundam",




"Pali",




"Satna",




"Vizianagaram",




"Katihar",
"Hardwar",




"Sonipat",




"Nagercoil",




"Thanjavur",




"Murwara(Katni)",




"Naihati",




"Sambhal",




"Nadiad",




"Yamunanagar",




"EnglishBazar",
"England",



"Eluru",




"Munger",




"Panchkula",




"Raayachuru",




"Panvel",




"Deoghar",




"Ongole",




"Nandyal",




"Morena",




"Bhiwani",




"Porbandar",




"Palakkad",




"Anand",




"Purnia",




"Baharampur",




"Barmer",




"Morvi",




"Orai",




"Bahraich",




"Sikar",




"Vellore",




"Singrauli",




"Khammam",




"Mahesana",




"Silchar",




"Sambalpur",




"Rewa",




"Unnao",




"Hugli-Chinsurah",




"Raiganj",




"Phusro",




"Adityapur",




"Alappuzha",




"Bahadurgarh",




"Machilipatnam",




"RaeBareli",




"Jalpaiguri",




"Bharuch",




"Pathankot",




"Hoshiarpur",




"Baramula",




"Adoni",




"Jind",




"Tonk",




"Tenali",




"Kancheepuram",




"Vapi",




"Sirsa",




"Navsari",




"Mahbubnagar",




"Puri",




"RobertsonPet",




"Erode",




"Batala",




"Haldwani-cum-Kathgodam",




"Vidisha",




"Saharsa",




"Thanesar",




"Chittoor",




"Veraval",




"Lakhimpur",




"Sitapur",




"Hindupur",




"Santipur",




"Balurghat",




"Ganjbasoda",




"Moga",




"Proddatur",




"Srinagar",




"Medinipur",




"Habra",




"Sasaram",




"Hajipur",




"Bhuj",




"Shivpuri",




"Ranaghat",




"Shimla",




"Tiruvannamalai",




"Kaithal",




"Rajnandgaon",




"Godhra",




"Hazaribag",




"Bhimavaram",




"Mandsaur",




"Dibrugarh",




"Kolar",




"Bankura",




"Mandya",




"Dehri-on-Sone",




"Madanapalle",




"Malerkotla",




"Lalitpur",




"Bettiah",




"Pollachi",




"Khanna",




"Neemuch",




"Palwal",




"Palanpur",




"Guntakal",




"Nabadwip",




"Udupi",




"Jagdalpur",




"Motihari",




"Pilibhit",




"Dimapur",




"Mohali",




"Sadulpur",




"Rajapalayam",




"Dharmavaram",




"Kashipur",




"Sivakasi",




"Darjiling",




"Chikkamagaluru",




"Gudivada",




"BaleshwarTown",




"Mancherial",




"Srikakulam",




"Adilabad",




"Yavatmal",




"Barnala",




"Nagaon",




"Narasaraopet",




"Raigarh",




"Roorkee",




"Valsad",




"Ambikapur",




"Giridih",




"Chandausi",




"Purulia",




"Patan",




"Bagaha",




"Hardoi",




"Achalpur",




"Osmanabad",




"Deesa",




"Nandurbar",




"Azamgarh",




"Ramgarh",




"Firozpur",




"BaripadaTown",




"Karwar",




"Siwan",




"Rajampet",




"Pudukkottai",




"Anantnag",




"Tadpatri",




"Satara",




"Bhadrak",




"Kishanganj",




"Suryapet",




"Wardha",




"Ranebennuru",




"Amreli",




"Neyveli(TS)",




"Jamalpur",




"Marmagao",
"Goa",



"Udgir",




"Tadepalligudem",




"Nagapattinam",




"Buxar",




"Aurangabad",




"Jehanabad",




"Phagwara",




"Khair",




"SawaiMadhopur",




"Kapurthala",




"Chilakaluripet",




"Aurangabad",




"Malappuram",




"Rewari",




"Nagaur",




"Sultanpur",




"Nagda",




"PortBlair",




"Lakhisarai",




"Panaji",




"Tinsukia",




"Itarsi",




"Kohima",




"Balangir",




"Nawada",




"Jharsuguda",




"Jagtial",




"Viluppuram",




"Amalner",




"Zirakpur",




"Tanda",




"Tiruchengode",




"Nagina",




"Yemmiganur",




"Vaniyambadi",




"Sarni",




"TheniAllinagaram",




"Margao",




"Akot",




"Sehore",




"MhowCantonment",




"KotKapura",




"Makrana",




"Pandharpur",




"Miryalaguda",




"Shamli",




"Seoni",




"Ranibennur",




"Kadiri",




"Shrirampur",




"Rudrapur",




"Parli",




"Najibabad",




"Nirmal",




"Udhagamandalam",




"Shikohabad",




"JhumriTilaiya",




"Aruppukkottai",




"Ponnani",




"Jamui",




"Sitamarhi",




"Chirala",




"Anjar",




"Karaikal",




"Hansi",




"Anakapalle",




"Mahasamund",




"Faridkot",




"Saunda",




"Dhoraji",




"Paramakudi",




"Balaghat",




"Sujangarh",




"Khambhat",
"Muktsar",
"Rajpura",
"Kavali",
"Dhamtari",
"AshokNagar",




"Sardarshahar",




"Mahuva",




"Bargarh",




"Kamareddy",




"Sahibganj",




"Kothagudem",




"Ramanagaram",




"Gokak",




"Tikamgarh",




"Araria",




"Rishikesh",




"Shahdol",




"Medininagar(Daltonganj)",




"Arakkonam",




"Washim",




"Sangrur",




"Bodhan",




"Fazilka",




"Palacole",




"Keshod",




"Sullurpeta",




"Wadhwan",




"Gurdaspur",




"Vatakara",




"Tura",




"Narnaul",




"Kharar",




"Yadgir",




"Ambejogai",




"Ankleshwar",




"Savarkundla",




"Paradip",




"Virudhachalam",




"Kanhangad",




"Kadi",




"Srivilliputhur",




"Gobindgarh",




"Tindivanam",




"Mansa",




"Taliparamba",




"Manmad",




"Tanuku",




"Rayachoti",




"Virudhunagar",




"Koyilandy",




"Jorhat",




"Karur",




"Valparai",




"Srikalahasti",




"Neyyattinkara",




"Bapatla",




"Fatehabad",




"Malout",




"Sankarankovil",




"Tenkasi",




"Ratnagiri",




"RabkaviBanhatti",




"Sikandrabad",




"Chaibasa",




"Chirmiri",




"Palwancha",




"Bhawanipatna",




"Kayamkulam",




"Pithampur",




"Nabha",




"Shahabad,Hardoi",




"Dhenkanal",




"UranIslampur",




"Gopalganj",




"BongaigaonCity",




"Palani",




"Pusad",




"Sopore",




"Pilkhuwa",




"TarnTaran",




"Renukoot",




"Mandamarri",




"Shahabad",




"Barbil",




"Koratla",




"Madhubani",




"Arambagh",




"Gohana",




"Ladnu",




"Pattukkottai",




"Sirsi",




"Sircilla",




"Tamluk",




"Jagraon",




"AlipurdUrbanAgglomerationr",




"Alirajpur",




"Tandur",




"Naidupet",




"Tirupathur",




"Tohana",




"Ratangarh",




"Dhubri",




"Masaurhi",




"Visnagar",




"Vrindavan",




"Nokha",




"Nagari",




"Narwana",




"Ramanathapuram",




"Ujhani",




"Samastipur",




"Laharpur",




"Sangamner",




"Nimbahera",




"Siddipet",




"Suri",




"Diphu",




"Jhargram",




"Shirpur-Warwade",




"Tilhar",




"Sindhnur",




"Udumalaipettai",




"Malkapur",




"Wanaparthy",




"Gudur",




"Kendujhar",




"Mandla",




"Mandi",




"Nedumangad",




"NorthLakhimpur",




"Vinukonda",




"Tiptur",




"Gobichettipalayam",




"Sunabeda",




"Wani",




"Upleta",




"Narasapuram",




"Nuzvid",




"Tezpur",




"Una",




"Markapur",




"Sheopur",




"Thiruvarur",




"Sidhpur",




"Sahaswan",




"Suratgarh",




"Shajapur",




"Rayagada",




"Lonavla",
"London",
"Queens",


"Ponnur",




"Kagaznagar",




"Gadwal",




"Bhatapara",




"Kandukur",




"Sangareddy",




"Unjha",




"Lunglei",




"Karimganj",




"Kannur",




"Bobbili",




"Mokameh",




"TalegaonDabhade",




"Anjangaon",




"Mangrol",




"Sunam",




"Gangarampur",




"Thiruvallur",




"Tirur",




"Rath",




"Jatani",




"Viramgam",




"Rajsamand",




"Yanam",




"Kottayam",




"Panruti",




"Dhuri",




"Namakkal",




"Kasaragod",




"Modasa",




"Rayadurg",




"Supaul",




"Kunnamkulam",




"Umred",




"Bellampalle",




"Sibsagar",




"MandiDabwali",




"Ottappalam",




"Dumraon",




"Samalkot",




"Jaggaiahpet",




"Goalpara",




"Tuni",




"Lachhmangarh",




"Bhongir",




"Amalapuram",




"FirozpurCantt.",




"Vikarabad",




"Thiruvalla",




"Sherkot",




"Palghar",




"Shegaon",




"Jangaon",




"Bheemunipatnam",




"Panna",




"Thodupuzha",




"KathUrbanAgglomeration",




"Palitana",




"Arwal",




"Venkatagiri",




"Kalpi",




"Rajgarh(Churu)",




"Sattenapalle",




"Arsikere",




"Ozar",




"Thirumangalam",




"Petlad",




"Nasirabad",




"Phaltan",




"Rampurhat",




"Nanjangud",




"Forbesganj",




"Tundla",




"BhabUrbanAgglomeration",




"Sagara",




"Pithapuram",




"Sira",




"Bhadrachalam",




"CharkhiDadri",




"Chatra",




"PalasaKasibugga",




"Nohar",




"Yevla",




"SirhindFatehgarhSahib",




"Bhainsa",




"Parvathipuram",




"Shahade",




"Chalakudy",




"Narkatiaganj",




"Kapadvanj",




"Macherla",




"Raghogarh-Vijaypur",




"Rupnagar",




"Naugachhia",




"Sendhwa",




"Byasanagar",




"Sandila",




"Gooty",




"Salur",




"Nanpara",




"Sardhana",




"Vita",




"Gumia",




"Puttur",




"JalandharCantt.",




"Nehtaur",




"Changanassery",




"Mandapeta",




"Dumka",




"Seohara",




"Umarkhed",




"Madhupur",




"Vikramasingapuram",




"Punalur",




"Kendrapara",




"Sihor",




"Nellikuppam",




"Samana",




"Warora",




"Nilambur",




"Rasipuram",




"Ramnagar",




"Jammalamadugu",




"Nawanshahr",




"Thoubal",




"Athni",




"Cherthala",




"Sidhi",




"Farooqnagar",




"Peddapuram",




"Chirkunda",




"Pachora",




"Madhepura",




"Pithoragarh",




"Tumsar",




"Phalodi",




"Tiruttani",




"RampuraPhul",




"Perinthalmanna",




"Padrauna",




"Pipariya",




"Dalli-Rajhara",




"Punganur",




"Mattannur",




"Mathura",




"Thakurdwara",




"Nandivaram-Guduvancheri",




"Mulbagal",




"Manjlegaon",




"Wankaner",




"Sillod",




"Nidadavole",




"Surapura",




"Rajagangapur",




"Sheikhpura",




"Parlakhemundi",




"Kalimpong",




"Siruguppa",




"Arvi",




"Limbdi",




"Barpeta",




"Manglaur",




"Repalle",




"Mudhol",




"Shujalpur",




"Mandvi",




"Thangadh",




"Sironj",




"Nandura",




"Shoranur",




"Nathdwara",




"Periyakulam",




"Sultanganj",




"Medak",




"Narayanpet",




"RaxaulBazar",




"Rajauri",




"Pernampattu",




"Nainital",




"Ramachandrapuram",




"Vaijapur",




"Nangal",




"Sidlaghatta",




"Punch",




"Pandhurna",




"WadgaonRoad",




"Talcher",




"Varkala",




"Pilani",




"Nowgong",




"NailaJanjgir",




"Mapusa",




"Vellakoil",




"MertaCity",




"Sivaganga",




"Mandideep",




"Sailu",




"Vyara",




"Kovvur",




"Vadalur",




"Nawabganj",




"Padra",




"Sainthia",




"Siana",




"Shahpur",




"Sojat",




"Noorpur",




"Paravoor",




"Murtijapur",




"Ramnagar",




"Sundargarh",




"Taki",




"Saundatti-Yellamma",




"Pathanamthitta",




"Wadi",




"Rameshwaram",




"Tasgaon",




"SikandraRao",




"Sihora",




"Tiruvethipuram",




"Tiruvuru",




"Mehkar",




"Peringathur",




"Perambalur",




"Manvi",




"Zunheboto",




"MahnarBazar",




"Attingal",




"Shahbad",




"Puranpur",




"Nelamangala",




"Nakodar",




"Lunawada",




"Murshidabad",




"Mahe",




"Lanka",




"Rudauli",




"Tuensang",




"Lakshmeshwar",




"Zira",




"Yawal",




"ThanaBhawan",




"Ramdurg",




"Pulgaon",




"Sadasivpet",




"Nargund",




"Neem-Ka-Thana",




"Memari",




"Nilanga",




"Naharlagun",




"Pakaur",




"Wai",




"Tarikere",




"Malavalli",




"Raisen",




"Lahar",




"Uravakonda",




"Savanur",




"Sirohi",




"Udhampur",




"Umarga",




"Pratapgarh",




"Lingsugur",



"Usilampatti",




"PaliaKalan",




"Wokha",




"Rajpipla",




"Vijayapura",




"Rawatbhata",




"Sangaria",




"Paithan",




"Rahuri",




"Patti",




"Zaidpur",




"Lalsot",




"Maihar",




"Vedaranyam",




"Nawapur",




"Solan",




"Vapi",




"Sanawad",




"Warisaliganj",




"Revelganj",




"Sabalgarh",




"Tuljapur",




"Simdega",




"Musabani",




"Kodungallur",




"Phulabani",




"Umreth",




"Narsipatnam",




"Nautanwa",




"Rajgir",




"Yellandu",




"Sathyamangalam",




"Pilibanga",




"Morshi",




"Pehowa",




"Sonepur",




"Pappinisseri",




"Zamania",




"Mihijam",




"Purna",




"Puliyankudi",




"Shikarpur,Bulandshahr",




"Umaria",




"Porsa",




"NaugawanSadat",




"FatehpurSikri",




"Manuguru",




"Udaipur",




"PiparCity",




"Pattamundai",




"Nanjikottai",




"Taranagar",




"Yerraguntla",




"Satana",




"Sherghati",




"Sankeshwara",




"Madikeri",




"Thuraiyur",




"Sanand",




"Rajula",




"Kyathampalle",




"Shahabad,Rampur",




"TildaNewra",




"Narsinghgarh",




"Chittur-Thathamangalam",




"MalajKhand",




"Sarangpur",




"Robertsganj",




"Sirkali",




"Radhanpur",




"Tiruchendur",




"Utraula",




"Patratu",




"Vijainagar,Ajmer",




"Periyasemur",




"Pathri",




"Sadabad",




"Talikota",




"Sinnar",




"Mungeli",




"Sedam",




"Shikaripur",




"Sumerpur",




"Sattur",




"Sugauli",




"Lumding",




"Vandavasi",




"Titlagarh",




"Uchgaon",




"Mokokchung",




"PaschimPunropara",




"Sagwara",




"RamganjMandi",




"Tarakeswar",




"Mahalingapura",




"Dharmanagar",




"Mahemdabad",




"Manendragarh",




"Uran",




"Tharamangalam",




"Tirukkoyilur",




"Pen",




"Makhdumpur",




"Maner",




"Oddanchatram",




"Palladam",




"Mundi",




"Nabarangapur",




"Mudalagi",




"Samalkha",




"Nepanagar",




"Karjat",




"Ranavav",




"Pedana",




"Pinjore",




"Lakheri",




"Pasan",




"Puttur",




"Vadakkuvalliyur",




"Tirukalukundram",




"Mahidpur",




"Mussoorie",




"Muvattupuzha",




"Rasra",




"Udaipurwati",




"Manwath",




"Adoor",




"Uthamapalayam",




"Partur",




"Nahan",




"Ladwa",




"Mankachar",




"Nongstoin",




"Losal",




"SriMadhopur",




"Ramngarh",




"Mavelikkara",




"Rawatsar",




"Rajakhera",




"Lar",




"LalGopalganjNindaura",




"Muddebihal",




"Sirsaganj",




"Shahpura",




"Surandai",




"Sangole",




"Pavagada",




"Tharad",




"Mansa",




"Umbergaon",




"Mavoor",




"Nalbari",




"Talaja",




"Malur",




"Mangrulpir",




"Soro",




"Shahpura",




"Vadnagar",




"Raisinghnagar",




"Sindhagi",




"Sanduru",




"Sohna",




"Manavadar",




"Pihani",




"Safidon",




"Risod",




"Rosera",




"Sankari",




"Malpura",




"Sonamukhi",




"Shamsabad,Agra",




"Nokha",




"PandUrbanAgglomeration",




"Mainaguri",




"Afzalpur",




"Shirur",




"Salaya",




"Shenkottai",




"Pratapgarh",




"Vadipatti",




"Nagarkurnool",




"Savner",




"Sasvad",




"Rudrapur",




"Soron",




"Sholingur",




"Pandharkaoda",




"Perumbavoor",




"Maddur",




"Nadbai",




"Talode",




"Shrigonda",




"Madhugiri",




"Tekkalakote",




"Seoni-Malwa",




"Shirdi",




"SUrbanAgglomerationr",




"Terdal",




"Raver",




"Tirupathur",




"Taraori",




"Mukhed",




"Manachanallur",




"Rehli",




"Sanchore",




"Rajura",




"Piro",




"Mudabidri",




"VadgaonKasba",




"Nagar",




"Vijapur",




"Viswanatham",




"Polur",




"Panagudi",




"Manawar",




"Tehri",




"Samdhan",




"Pardi",




"Rahatgarh",




"Panagar",




"Uthiramerur",




"Tirora",




"Rangia",




"Sahjanwa",




"WaraSeoni",




"Magadi",




"Rajgarh(Alwar)",




"Rafiganj",




"Tarana",




"RampurManiharan",




"Sheoganj",




"Raikot",




"Pauri",




"Sumerpur",




"Navalgund",




"Shahganj",




"Marhaura",




"Tulsipur",




"Sadri",




"Thiruthuraipoondi",




"Shiggaon",




"Pallapatti",




"Mahendragarh",




"Sausar",




"Ponneri",




"Mahad",




"Lohardaga",




"Tirwaganj",




"Margherita",




"Sundarnagar",




"Rajgarh",




"Mangaldoi",




"Renigunta",




"Longowal",




"Ratia",




"Lalgudi",




"Shrirangapattana",




"Niwari",




"Natham",




"Unnamalaikadai",




"PurqUrbanAgglomerationzi",




"Shamsabad,Farrukhabad",




"Mirganj",




"Todaraisingh",




"Warhapur",




"Rajam",




"UrmarTanda",




"Lonar",




"Powayan",




"P.N.Patti",




"Palampur",




"SrisailamProject(RightFlankColony)Township",




"Sindagi",




"Sandi",




"Vaikom",




"Malda",




"Tharangambadi",




"Sakaleshapura",




"Lalganj",




"Malkangiri",




"Rapar",




"Mauganj",




"Todabhim",




"Srinivaspur",



"Murliganj",




"Reengus",




"Sawantwadi",




"Tittakudi",




"Lilong",




"Rajaldesar",




"Pathardi",




"Achhnera",




"Pacode",




"Naraura",




"Nakur",




"Palai",




"Morinda,India",




"Manasa",




"Nainpur",




"Sahaspur",




"Pauni",




"Prithvipur",




"Ramtek",




"Silapathar",




"Songadh",




"Safipur",




"Sohagpur",




"Mul",




"Sadulshahar",




"Phillaur",




"Sambhar",




"Prantij",




"Nagla",




"Pattran",




"MountAbu",




"Reoti",




"Tenudam-cum-Kathhara",




"Panchla",




"Sitarganj",




"Pasighat",




"Motipur",




"O'Valley",




"Raghunathpur",




"Suriyampalayam",




"Qadian",




"Rairangpur",




"Silvassa",




"Nowrozabad(Khodargama)",




"Mangrol",




"Soyagaon",




"Sujanpur",




"Manihari",




"Sikanderpur",




"Mangalvedhe",




"Phulera",




"Ron",
"Sholavandan",




"Saidpur",




"Shamgarh",




"Thammampatti",




"Maharajpur",




"Multai",




"Mukerian",




"Sirsi",




"Purwa",




"Sheohar",




"Namagiripettai",




"Parasi",




"Lathi",




"Lalganj",




"Narkhed",




"Mathabhanga",




"Shendurjana",




"Peravurani",




"Mariani",




"Phulpur",




"Rania",




"Pali",




"Pachore",




"Parangipettai",




"Pudupattinam",




"Panniyannur",




"Maharajganj",




"Rau",




"Monoharpur",




"Mandawa",




"Marigaon",




"Pallikonda",




"Pindwara",




"Shishgarh",




"Patur",




"MayangImphal",




"Mhowgaon",




"Guruvayoor",




"Mhaswad",




"Sahawar",




"Sivagiri",




"Mundargi",
"Punjaipugalur",




"Kailasahar",




"Samthar",




"Sakti",




"Sadalagi",



"Silao",




"Mandalgarh",




"Loha",




"Pukhrayan",




"Padmanabhapuram",




"Belonia",




"Saiha",




"Srirampore",
"Talwara",




"Puthuppally",




"Khowai",




"Vijaypur",




"Takhatgarh",




"Thirupuvanam",




"Adra",




"Piriyapatna",



"Obra",




"Adalaj",




"Nandgaon",




"Barh",




"Chhapra",




"Panamattom",




"Niwai",




"Bageshwar",




"Tarbha",




"Adyar",



"Narsinghgarh",




"Warud",




"Asarganj",




"Sarsod",
"Gandhinagar",
"Kullu",
"Himachal pradesh",
"Manali",
"Mirzapur",
"Uttar pradesh",
"Kota",
"Rajasthan",
"Dispur",
"Assam",
"Ghaziabad",
"Muradnagar","Kanouja",
"Telangana",
"AndamanandNicobarIslands",
"Andhra pradesh",
"Arunachal pradesh",
"Bihar",
"Chandigarh",
"Chhattisgarh",
"Dadraand nagar haveli",
"Daman and diu",
"Delhi",
"Goa",
"Gujarat",
"Haryana",
"Jammu and kashmir",
"Jharkhand",
"Karnataka",
"Kerala",
"Ladakh",
"Lakshadweep",
"Madhya pradesh",
"Manipur",
"Meghalaya",
"Mizoram",
"Nagaland",
"Odisha",
"Puducherry",
"Punjab",
"Rajasthan",
"Sikkim",
"Maharashtra",
"TamilNadu",
"Telangana",
"Tripura",
"Uttarakhand",
"Westbengal"
]

export default Countries;